<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
  </cTable>
</template>

<script>
import { getAirPerformance } from "@/api/performance/airPerformance";

import cTable from "@/base/common/index";
export default {
  name: "airPerformance",
  components: {
    cTable,
  },
  data() {
    return {
      methods: {
        list: (p) => getAirPerformance(p),
      },
      config: {
        height: 630,
      },
      modals: {},
      header: {
        searchs: [
          // {
          //   key: "dateType",
          //   component: "Select",
          //   placeholder() {
          //     return this.$t("select") + this.$t("date") + this.$t("type");
          //   },
          //   clearable: true,
          //   options: [
          //     { label: this.$t('week'), value: "week" },
          //     { label: this.$t('month_t'), value: "month" },
          //   ],
          //   default: "month",
          //   bind: {
          //     style: "width:150px",
          //   },
          // },
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "date",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "175px",
              },
            },
            default: () => {
              let date = new Date();
              date.setDate("01");
              return date;
            },
            methods: {
              format({ searchForm, value, newFormData }) {
                newFormData.temp = 1;
                return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              },
              // "on-change"({ searchForm }) {
              //   searchForm.startTime = searchForm.startTime
              //     ? this.$page.format.timeFormat(searchForm.startTime)
              //     : "";
              // }
            },
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("end") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "date",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "175px",
              },
            },
            default: () => {
              let date = new Date();
              return date;
            },
            methods: {
              format({ searchForm, value, newFormData }) {
                newFormData.temp = 1;
                return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              },
              // "on-change"({ searchForm }) {
              //   let time = this.$page.format.timeFormat(searchForm.endTime);
              //   if (time.slice(-8) === "00:00:00") {
              //     time = time.split(" ")[0] + " " + "23:59:59";
              //     searchForm.endTime = time;
              //   }
              // }
            },
          },

          // {
          //   key: "toCountry",
          //   component: "Select",
          //   placeholder() {
          //     return this.$t("select") + this.$t("countryCode");
          //   },
          //   clearable: true,
          //   options: [],
          //   config: { label: "code", value: "code" },
          //   bind: {
          //     style: "width:150px",
          //   },
          // },
          // {
          //   key: "clientId",
          //   component: "Select",
          //   placeholder() {
          //     return this.$t("select") + this.$t("clientName");
          //   },
          //   clearable: true,
          //   options: [],
          //   config: { label: "account", value: "id" },
          //   bind: {
          //     style: "width:150px",
          //   },
          // },
          // {
          //   key: "channelCode",
          //   component: "Select",
          //   placeholder() {
          //     return this.$t("select") + this.$t("channel_name");
          //   },
          //   clearable: true,
          //   options: [],
          //   config: {
          //     label({ row }) {
          //       return row.channel_name + "-" + row.channel_code;
          //     },
          //     value: "channel_code"
          //   },
          //   bind: {
          //     style: "width:150px"
          //   }
          // },
          // {
          //   key: "codType",
          //   component: "Select",
          //   placeholder() {
          //     return this.$t("select") + this.$t("cod_type");
          //   },
          //   clearable: true,
          //   options: [
          //     { label: "NCND", value: "NCND" },
          //     {
          //       label: "NOR",
          //       value: "NOR"
          //     }
          //   ],
          //   bind: {
          //     style: "width:150px"
          //   }
          // },
          // {
          //   key: "deliver",
          //   component: "Select",
          //   placeholder() {
          //     return this.$t("select") + "地派";
          //   },
          //   clearable: true,
          //   options: [],
          //   config: { label: "agent_name", value: "agent_name" },
          //   bind: {
          //     style: "width:140px"
          //   }
          // },
          // {
          //   key: "noUpdateDay",
          //   component: "Select",
          //   placeholder() {
          //     return this.$t("select") + "无更新天数";
          //   },
          //   clearable: true,
          //   options: [],
          //   // config: { label: "agent_name", value: "agent_name" },
          //   bind: {
          //     style: "width:140px"
          //   }
          // },
          // {
          //   key: "trackerStatus",
          //   component: "Select",
          //   placeholder() {
          //     return this.$t("select") + this.$t("tracker_code");
          //   },
          //   clearable: true,
          //   options: [],
          //   config: { label: "tracker_code", value: "tracker_code" },
          //   bind: {
          //     style: "width:140px"
          //   }
          // },
          // {
          //   key: "keywords",
          //   placeholder() {
          //     return this.$t("keyword");
          //   },
          //   bind: {
          //     style: "width:140px",
          //     type: "textarea",
          //     rows: 1,
          //   },
          //   component: "Input",
          // },
        ],
        btns: {
          list: [
            // {
            //   name: this.$t("analysis1"),
            //   type: "add",
            //   fnName: "add",
            //   bind: {
            //     type: "warning"
            //   }
            // },
            {
              name: this.$t("export"),
              type: "export",
              fnName: "export",
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
          ],
          methods: {
            export() {
              this.openLoading();
              this.handleRequestMethods(
                "list",
                { export: 1 },
                false,
                true
              ).then((res) => {
                window.open(this.$globalUrl + res.payload.src);
              });
            },
          },
        },
      },
      fields: [
        {
          name: () => this.$t("statistics") + this.$t("date"),
          key: "date",
          width: 130,
        },
        {
          name: () => this.$t("serviceAccount"),
          key: "account",
          width: 130,
          tooltip: true,
        },
        {
          name: () => this.$t("extract_nums"),
          children: [
            {
              name: () => this.$t("this_month"),
              key: "extract_nums",
            },
            {
              name: () => this.$t("last_month"),
              key: "last_extract_nums",
            },
          ],
        },
        {
          name: () => this.$t("pass_nums"),
          children: [
            {
              name: () => this.$t("this_month"),
              key: "first_pass",
            },
            {
              name: () => this.$t("last_month"),
              key: "last_first_pass",
            },
          ],
        },
        {
          name: () => this.$t("pass_rate"),
          children: [
            {
              name: () => this.$t("this_month"),
              key: "standard_rate",
            },
            {
              name: () => this.$t("last_month"),
              key: "last_standard_rate",
            },
          ],
        },

        // {
        //   name: () => this.$t("order_pods"),
        //   key: "order_pods",
        // },
        // {
        //   name: () => this.$t("last_order_pods"),
        //   key: "last_order_pods",
        // },
        // {
        //   name: () => this.$t("pod_rate"),
        //   key: "pod_rate",
        // },
        // {
        //   type: "btns",
        //   width: 100,
        //   name: () => this.$t("operation"),
        //   fixed: "right",
        //   list: [
        //     {
        //       name: () => this.$t("export"),
        //       type: "export",
        //       fnName: "exportFun",
        //       bind: {
        //         type: "warning",
        //       },
        //     },
        //   ],

        //   methods: {
        //     exportFun({ row }) {
        //       let data = JSON.parse(
        //         JSON.stringify(this.$refs["header"].searchForm)
        //       );
        //       data["staff_id"] = row.staff_id;
        //       data["startTime"] = data["startTime"]
        //         ? this.format.dateFormat(data["startTime"], "YYYY-MM-DD")
        //         : "";
        //       data["endTime"] = data["endTime"]
        //         ? this.format.dateFormat(data["endTime"], "YYYY-MM-DD")
        //         : "";
        //       this.openLoading();
        //       this.handleRequestMethods(
        //         "exportPerformance",
        //         data,
        //         false,
        //         true
        //       ).then((res) => {
        //         window.open(this.$globalUrl + res.payload.src);
        //       });
        //     },
        //   },
        // },
      ],
    };
  },
  // mounted() {
  //   this.header.searchs.forEach(async (item) => {
  //     if (item.key === "clientId")
  //       item.options = (await getAllClient()).data.payload.rows;
  //     if (item.key === "toCountry")
  //       item.options = (await getCountry()).data.payload.rows;
  //     // if (item.key === "channelCode")
  //     //   item.options = (await getChannel()).data.payload.rows;
  //     // if (item.key === "deliver")
  //     //   item.options = (
  //     //     await getAgent({ agent_type: "bag" })
  //     //   ).data.payload.rows;
  //     // if (item.key === "noUpdateDay")
  //     //   item.options = (
  //     //     await getSelectType(["ANALYZE_SELECT_DAY"])
  //     //   ).data.payload["ANALYZE_SELECT_DAY"];
  //     // if (item.key === "trackerStatus")
  //     //   item.options = (await getStatus({ pageSize: 9999 })).data.payload.rows;
  //   });
  // },
};
</script>
